import dayjs from '@/lib/dayjs'

export default function ServiceCaseStatus({ serviceCase }) {
    const { status_config, type_config, is_archived } = serviceCase
    const classes = is_archived
        ? { bg: 'bg-gray-50', text: 'text-gray-700', border: 'border-gray-200' }
        : status_config.classes
    const TypeIcon = type_config?.icon

    return (
        <div className={`border ${classes.border} p-5 rounded-xl flex justify-between items-center ${classes.bg}`}>
            <div className="flex flex-col">
                <span className={`font-semibold text-lg ${classes.text}`}>
                    {is_archived ? 'Archivé' : status_config.label}
                </span>

                <span className="text-sm text-gray-500">
                    Depuis {dayjs().to(dayjs(serviceCase.current_status_at), true)}
                    {' — '}
                    {dayjs(serviceCase.current_status_at).format('ll à HH:mm')}
                </span>
            </div>

            <span className="flex items-center gap-1.5 text-gray-500">
                {TypeIcon && <TypeIcon width={16} height={16} />}
                {type_config?.label}
            </span>
        </div>
    )
}
